import { Card, CardContent } from '../components/ui/card';
import { Heart } from 'lucide-react';

const DonationsPage = () => {
  return (
    <div className="space-y-6" data-testid="donations-page">
      <div>
        <h1 className="text-3xl font-bold">Doações</h1>
        <p className="text-muted-foreground mt-1">Gerencie caixinhas e doações</p>
      </div>

      <Card className="border-dashed">
        <CardContent className="flex flex-col items-center justify-center py-12">
          <Heart className="w-12 h-12 text-muted-foreground mb-4" />
          <p className="text-muted-foreground text-center">
            Módulo de doações em desenvolvimento
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default DonationsPage;
